<template>
  <loading-overlay :active="isLoading" :is-full-page="true" :width="128" :height="128" loader="spinner" color="rgb(var(--color-active-hsl-128))" background-color="rgb(var(--color-b-back))" />
  <SrcBackgroundScroll @scrolled="isShrunk = $event">
    <HeadlineSubScroll 
        :title="$t('settings.easycheck')" 
        target="/Settings" 
        :hassubline="!isShrunk"
        :hasmenu="false"
        :isShrunk="isShrunk"
        >
          <template #icon>
            <IconEasyCheckIn             
              class="transition-all duration-300"
              :class="isShrunk ? 'w-8 h-8' : 'w-12 h-12'"/>
          </template>
          <template #subline>
            {{ $t('settings.settingsfor',{wallbox:this.decodeHtml(this.$store.state.WbName)} ) }}
          </template>
    </HeadlineSubScroll>


    <SettingsHeader :admin="this.$store.state.Role=='admin'">
      {{ this.decodeHtml(this.$store.state.WbName) }}
    </SettingsHeader>

    <SettingsBody>
      <template v-slot:formgrid>

          <ConfirmLeaveModal
            v-model:show="showLeaveDialog"
            :pendingNavigation="this.leaveDialog"
          />

          <div class="form-group sm:col-span-2">
            <TextfieldWithLabel
              :label="$t('seteasycheck.licenseinfo')"
              :text="ec_licensetxt"
            />
          </div>
          <div class="form-group sm:col-span-2">
            <TextfieldWithLabel
              :text="$t('seteasycheck.help')"
            />
          </div>
          <!--
          <div class="w-full sm:col-span-2 text-right">     
            <button @click.prevent="submitForm" class="
            px-4 py-2 h-12
            rounded-lg border-2 border-transparent
            font-semibold text-lg text-skin-b-invt 
            bg-skin-active128
            disabled:opacity-50 disabled:hover:bg-skin-active128 
            hover:bg-skin-active96
            focus:bg-skin-active128 focus:outline-none focus:ring-0 
            active:bg-skin-active128 
            transition duration-300 ease-in-out">
              Lizenzinformationen abrufen
            </button>
          </div>-->
      </template>
    </SettingsBody>

    <SettingsHeader v-if="!isLoading" class="mt-6" :admin="this.$store.state.Role=='admin'">
      <span v-if="is_ec_master">{{ $t('seteasycheck.isonwallbox',{wallbox:ec_mastername}) }}</span>
      <span v-else>{{ $t('seteasycheck.willbeactivated',{wallbox:this.decodeHtml(this.$store.state.WbLogName)}) }}</span>
    </SettingsHeader>

    <SettingsBody>
      <template v-slot:formgrid>

          <div class="mt-2 mb-2 sm:col-span-2">
            <ToggleWithLabel 
                v-model="easycheckmode"
                :label="$t('seteasycheck.easycheck')"
                :ontext="$t('common.on')"
                :offtext="$t('common.off')"
                @update:modelValue ="onChange"
            />
          </div>

          <div class="mt-2 mb-2 sm:col-span-2">
            <ToggleWithLabel 
                v-model="easycheckreader"
                :disabled="!easycheckmode"
                :label="$t('seteasycheck.reader')"
                :ontext="$t('common.yes')"
                :offtext="$t('common.no')"
                @update:modelValue ="onChange"
            />
          </div>
          <!--
          <div class="mt-2 mb-2 sm:col-span-2">
            <TextfieldWithLabel
              :text="pairingstxt"
            />
            <ActionButton 
              v-if="this.pairingsECI==0"
              @click="updaterfidtyp()"
              :disabled="!easycheckmode"
              :wfull="false"
              :margin="true"
              >
              {{ $t('seteasycheck.changeeci', { count: this.pairingsall-this.pairingsECI }) }}
            </ActionButton>

            <router-link to="/Cards" custom v-slot="{ navigate }">
                <button type="button" @click="navigate" role="link"
                :disabled="!easycheckmode"
                class="
                  px-4 py-2 h-12 mt-2
                  rounded-lg border-2 border-transparent
                  font-semibold text-lg text-skin-b-invt 
                  bg-skin-active128
                  disabled:opacity-50 disabled:hover:bg-skin-active128 
                  hover:bg-skin-active96
                  focus:bg-skin-active128 focus:outline-none focus:ring-0 
                  active:bg-skin-active128 
                  transition duration-300 ease-in-out">
                    {{$t('seteasycheck.torfid')}}
                </button>
            </router-link>
          </div>
-->
          <div v-if="is_ec_master" class="form-group mb-6 sm:col-span-2 sm:flex sm:items-end">
            <div class="sm:grow sm:mr-4">
              <InputLabelError 
                :disabled="true"
                :value="'https://'+ec_masterip+'/easycheck/'"
                :label="$t('seteasycheck.url')"
                :placeholder="$t('seteasycheck.url')"
                :validator_off="true"
              />          
            </div>

            <div v-if="is_ec_master" class="inline-flex">     
              <a id="ec_urlbutton" type="button" :href="'https://'+ec_masterip+'/easycheck/'" target="_blank" class="
                w-full px-4 py-2 h-12
                rounded-lg border-2 border-transparent
                font-semibold text-lg text-skin-b-invt 
                bg-skin-active128
                disabled:opacity-50 disabled:hover:bg-skin-active128 
                hover:bg-skin-active96
                focus:bg-skin-active128 focus:outline-none focus:ring-0 
                active:bg-skin-active128 
                transition duration-300 ease-in-out">
                {{ $t('seteasycheck.website',{wallbox:ec_mastername}) }}
              </a>
            </div>
          </div>

        </template>
        <template v-slot:formbottom>
          <ActionButton :disabled="!isDirty" @click="saveeasyCheck()">
            {{ $t('common.save') }}
          </ActionButton>
        </template>
    </SettingsBody>
</SrcBackgroundScroll>
</template>

<script>
import SrcBackgroundScroll from './sources/SrcBackgroundScroll.vue'
import HeadlineSubScroll from './elements/HeadlineSubScroll.vue'
import IconEasyCheckIn from './icons/IconEasyCheckIn.vue'
import SettingsHeader from './elements/SettingsHeader.vue'
import SettingsBody from './elements/SettingsBody.vue'
import ActionButton from './elements/ActionButton.vue'
import InputLabelError from './elements/InputLabelError.vue'
import ToggleWithLabel from './elements/ToggleWithLabel.vue'
import TextfieldWithLabel from './elements/TextfieldWithLabel.vue'
import ConfirmLeaveModal from './elements/ConfirmLeaveModal.vue'
import { useI18n } from 'vue-i18n'

export default {
  setup () {
      const { t,d,n } = useI18n()
      return { t,d,n }
    },
  components: {
      SrcBackgroundScroll, HeadlineSubScroll, IconEasyCheckIn,
      SettingsHeader, SettingsBody, ActionButton,
      InputLabelError, ToggleWithLabel, TextfieldWithLabel, ConfirmLeaveModal
    }, 
  data() {
    return {
          isLoading: false,
          saveto: this.$store.state.WbId,
          easycheck_onoff: 0,       
          easycheckmode: false,
          easycheck_licensed: 0,
          easycheck_reader: 0,
          easycheckreader: false,
          pairingsall: 0,
          pairingsECI: 0,
          pairingstxt: '',
          is_ec_master: false,
          ec_master: [],
          ec_masterid: '',
          ec_masterip: '',
          ec_mastername: '',
          ec_licensetxt: this.$t('seteasycheck.licenseinfo'),
          isShrunk: false,

          isDirty:false,
          showLeaveDialog:false
    }
  },
  computed: {
  },
  beforeRouteLeave(to, from, next) {

    if (this.isDirty) {
      this.showLeaveDialog = true;
      this.pendingNavigation = next;    
    } else {
      next();
    }
  },
  methods: {
    onChange() {this.isDirty = true;},
    leaveDialog(){this.pendingNavigation();},

    decodeHtml: function(html) {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
      },
    saveeasyCheck() {
      this.isDirty = false;
      if(this.easycheckmode){
        this.easycheck_onoff=1;
        this.is_ec_master = true;
      }
      else{
        this.easycheck_onoff=0;
        this.is_ec_master = false;
      }

      if(this.easycheckreader)
        this.easycheck_reader=1;
      else
        this.easycheck_reader=0;
      this.axios
      .get('wallbox/checkin.php?action=update_checkin_settings&enabled='+this.easycheck_onoff+'&reader_available='+this.easycheck_reader+'&auto_enabled=-1&client='+this.ec_masterid+'&user='+this.$store.state.token)
      .then((response) => {      
                  if(response.data.status=='ok'){
                    this.ec_saved = true;
                    console.log('easyCheck Settings gespeichert');
                  }else{
                    console.log('Fehler beim speichern der easyCheck Settings');                   
                  }
                })
      .catch((errors) => {
          console.log(errors); // Errors
      });
    },
    updaterfidtyp() {
      this.isLoading = true;
      this.axios
      .get('wallbox/pairing.php?action=update_by_typ&user='+this.$store.state.token+'&typ=rfid&newtyp=rfid_checkin')
      .then((response) => {  
                if(response.data.status=='token'){
                      this.$router.push({path: '/'});             
                  }
                else if(response.data.status=='ok'){
                    console.log('update rfid type done');
                  }else{
                    console.log('Error update rfid type');                   
                  }
                })
      .catch((errors) => {
          console.log(errors); // Errors
      })
      .then(() => {
        this.fetchdata();
      });  
    },
    fetchdata() {
      this.axios
          .get('wallbox/checkin.php?action=search_master&user='+this.$store.state.token)
          .then((RESPONSE) => {    
                    if(RESPONSE.data.status=='token'){
                        this.$router.push({path: '/'});             
                    }
                    else if(RESPONSE.data.status=='ok'){ 
                        if(RESPONSE.data.master!='-1'){ //EC-Master vorhanden

                          let checkinSettingsUrl = 'wallbox/checkin.php?action=get_checkin_settings&user='+this.$store.state.token+'&client='+RESPONSE.data.master;
                          let clientlistUrl = 'wallbox/client.php?action=get_clients&user='+this.$store.state.token;
                          let pairingsUrl = '/wallbox/pairing.php?action=list_dist_pairings&user='+this.$store.state.token;

                          const requestcheckinSettings = this.axios.get(checkinSettingsUrl);      
                          const requestclientlist = this.axios.get(clientlistUrl);
                          const requestpairings = this.axios.get(pairingsUrl);
                          this.axios
                              .all([requestcheckinSettings, requestclientlist, requestpairings])
                              .then(
                                  this.axios.spread((...responses) => {
                                      const responsecheckinSettings = responses[0];
                                      const responseclientlist = responses[1];
                                      const responsepairings = responses[2];

                                      if(responsecheckinSettings.data.status=='ok'){

                                        this.easycheck_onoff = responsecheckinSettings.data.tbl_checkin_settings.enabled;  
                                        this.easycheck_licensed = responsecheckinSettings.data.tbl_checkin_settings.licensed;
                                        this.easycheck_reader = responsecheckinSettings.data.tbl_checkin_settings.reader;
                                        if(this.easycheck_onoff==1)
                                          this.easycheckmode=true;
                                        else
                                          this.easycheckmode=false;
                                        console.log(this.easycheckmode);
                                        if(this.easycheck_reader==1)
                                          this.easycheckreader=true;
                                        else
                                          this.easycheckreader=false;                                    
                                      }else{
                                        console.log('Error get Checkin Settings Table');
                                      }

                                      if(responseclientlist.data.status=='ok'){
                                        this.ec_master = responseclientlist.data.tbl_clients.filter((client) => client.id == RESPONSE.data.master);
                                        this.ec_masterid = RESPONSE.data.master;
                                        this.ec_masterip = this.ec_master[0].ip;
                                        this.ec_mastername = this.ec_master[0].name;
                                      }else{
                                        console.log('Error get client info');                   
                                      }

                                      if(responsepairings.data.status=='ok'){
                                        this.pairingsall = responsepairings.data.tbl_remote_pairing.filter((rfid) => rfid.typ === 'rfid').length;
                                        this.pairingsECI = responsepairings.data.tbl_remote_pairing.filter((rfid) => rfid.typ === 'rfid_checkin').length;
                                        this.pairingstxt = this.$t('seteasycheck.rfidall', { count: this.pairingsall }, this.pairingsall )+' '+
                                                           this.$t('seteasycheck.rfideci', { count: this.pairingsECI }, this.pairingsECI )+' ';
                                        if(this.pairingsall==0&&this.pairingsECI==0)
                                            this.pairingstxt += this.$t('seteasycheck.norfidhelp');
                                        else if(this.pairingsall>0&&this.pairingsECI==0)
                                            this.pairingstxt += this.$t('seteasycheck.justrfidhelp');
                                        else if(this.pairingsall>0&&this.pairingsECI>0)
                                            this.pairingstxt += this.$t('seteasycheck.easyrfidhelp');
                                      }else{
                                        console.log('Error get pairings list');                   
                                      }

                                    })
                              )      
                              .catch((errors) => {
                                console.log(errors); // Errors
                              })
                              .then(() => {
                                this.isLoading = false;
                              });


                          this.is_ec_master = true;


                        }else{ //EC-Master nicht vorhanden
                          let checkinSettingsUrl = 'wallbox/checkin.php?action=get_checkin_settings&user='+this.$store.state.token+'&client='+this.$store.state.WbLogId;
                          let clientinfoUrl = 'wallbox/client.php?action=client_info&user='+this.$store.state.token;
                          let pairingsUrl = '/wallbox/pairing.php?action=list_pairings&user='+this.$store.state.token;

                          const requestcheckinSettings = this.axios.get(checkinSettingsUrl);      
                          const requestclientinfo = this.axios.get(clientinfoUrl);
                          const requestpairings = this.axios.get(pairingsUrl);
                          this.axios
                              .all([requestcheckinSettings, requestclientinfo, requestpairings])
                              .then(
                                  this.axios.spread((...responses) => {
                                      const responsecheckinSettings = responses[0];
                                      const responseclientinfo = responses[1];
                                      const responsepairings = responses[2];

                                      if(responsecheckinSettings.data.status=='ok'){

                                        this.easycheck_onoff = responsecheckinSettings.data.tbl_checkin_settings.enabled;  
                                        this.easycheck_licensed = responsecheckinSettings.data.tbl_checkin_settings.licensed;
                                        this.easycheck_reader = responsecheckinSettings.data.tbl_checkin_settings.reader;
                                        if(this.easycheck_onoff==1)
                                          this.easycheckmode=true;
                                        else
                                          this.easycheckmode=false;  
                                        if(this.easycheck_reader==1)
                                          this.easycheckreader=true;
                                        else
                                          this.easycheckreader=false;                                        
                                      }else{
                                        console.log('Error get Checkin Settings Table');
                                      }

                                      if(responseclientinfo.data.status=='ok'){

                                        this.ec_masterid = this.$store.state.WbLogId;
                                        this.ec_masterip = responseclientinfo.data.tbl_clientsettings.ip;
                                        this.ec_mastername = responseclientinfo.data.tbl_clientsettings.name;

                                      }else{
                                        console.log('Error get client info');                   
                                      }

                                      if(responsepairings.data.status=='ok'){
                                        this.pairingsall = responsepairings.data.tbl_remote_pairing.filter((rfid) => rfid.typ === 'rfid').length;
                                        this.pairingsECI = responsepairings.data.tbl_remote_pairing.filter((rfid) => rfid.typ === 'rfid_checkin').length;
                                        this.pairingstxt = this.$t('seteasycheck.rfidall', { count: this.pairingsall }, this.pairingsall )+' '+
                                                           this.$t('seteasycheck.rfideci', { count: this.pairingsECI }, this.pairingsECI )+' ';
                                        if(this.pairingsall==0&&this.pairingsECI==0)
                                            this.pairingstxt += this.$t('seteasycheck.norfidhelp');
                                        else if(this.pairingsall>0&&this.pairingsECI==0)
                                            this.pairingstxt += this.$t('seteasycheck.justrfidhelp');
                                        else if(this.pairingsall>0&&this.pairingsECI>0)
                                            this.pairingstxt += this.$t('seteasycheck.easyrfidhelp');
                                      }else{
                                        console.log('Error get pairings list');                   
                                      }


                                    })
                              )      
                              .catch((errors) => {
                                console.log(errors); // Errors
                              })
                              .then(() => {
                                this.isLoading = false;
                              });
                          
                          this.is_ec_master = false;
                        }
                        
                    }else{
                        console.log('Error get checkin master data');                   
                    }
                  })
          .catch((errors) => {
            console.log(errors); // Errors
          });
    },
  },
  created() {  
      this.isLoading = true;

      this.axios
      .get('wallbox/checkin.php?action=get_checkin_settings&user='+this.$store.state.token+'&client='+this.$store.state.WbId)
      .then((response) => {  
                if(response.data.status=='token'){
                      this.$router.push({path: '/'});             
                  }
                else if(response.data.status=='ok'){
                    if(response.data.tbl_checkin_settings.licensed==1)
                        this.ec_licensetxt = this.$t('seteasycheck.licensetxtyes',{wallbox:this.$store.state.WbName});
                    else
                        this.ec_licensetxt = this.$t('seteasycheck.licensetxtno',{wallbox:this.$store.state.WbName});
                  }else{
                    console.log('Fehler beim Lesen der License Settings');                   
                  }
                })
      .catch((errors) => {
          console.log(errors); // Errors
      })
      .then(() => {
        this.fetchdata();
      });
  },
};
</script>

<style scoped>
</style>
